export default __webpack_public_path__ + "static/media/edit.05258d36.svg";